<template>
  <div v-if="conta" class="card card-body shadow-sm mt-0">
    <div class="form-header d-flex justify-content-between align-items-center">
      <h4 class="form-title">Detalhes da Conta Financeira</h4>
      <router-link to="/financeiro/contas-financeiras">
        <button class="btn btn-secondary btn-sm">Voltar</button>
      </router-link>
    </div>

    <div class="form-content mt-3">
      <FormSection title="Dados da Conta Financeira">
        <p><strong>Apelido:</strong> {{ conta.apelido || 'Não informado' }}</p>
        <p><strong>Instituição:</strong> {{ conta.instituicao || 'Não informado' }}</p>
        <p><strong>Agência:</strong> {{ conta.agencia || 'Não informado' }}</p>
        <p><strong>Número da Conta:</strong> {{ conta.numero_conta || 'Não informado' }}</p>
        <p><strong>Responsável:</strong> {{ conta.responsavel_nome || 'Não informado' }}</p>

        <!-- NOVO: Snapshot -->
        <p>
          <strong>Saldo de Referência:</strong>
          {{ formatCurrency(conta.saldo_atualizado) }}
          <small class="text-muted">
            (Atualizado em: {{ conta.saldo_atualizado_em ? formatDate(conta.saldo_atualizado_em) : '—' }})
          </small>
        </p>

        <!-- NOVO: Saldo Atual calculado -->
        <p>
          <strong>Saldo Atual: </strong>
          <span v-if="saldoLoading" class="text-muted">Calculando…</span>
          <span v-else-if="saldoError" class="text-danger">{{ saldoError }}</span>
          <span v-else>{{ formatCurrency(saldoInfo?.saldo_atual) }}</span>
          <small v-if="!saldoLoading && !saldoError" class="text-muted">
            (+{{ formatCurrency(saldoInfo?.total_receitas_pos || 0) }}
            / {{ formatCurrency(saldoInfo?.total_despesas_pos || 0) }})
          </small>
        </p>
      </FormSection>
    </div>
  </div>

  <div v-else>
    <LoadingSpinner />
  </div>
</template>

<script>
import axios from "@/services/axios";
import FormSection from "@/components/Layout/FormSection.vue";

export default {
  components: { FormSection },
  data() {
    return {
      conta: null,
      carregando: true,

      // saldo atual (endpoint /saldo)
      saldoInfo: null,
      saldoLoading: false,
      saldoError: ""
    };
  },
  methods: {
    formatCurrency(n) {
      if (n == null) return 'Desconhecido';
      const v = typeof n === "number" ? n : parseFloat(n || 0);
      return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" })
        .format(isNaN(v) ? 0 : v);
    },
    formatDate(d) {
      if (!d) return "—";
      try {
        const s = typeof d === "string" ? d.trim() : d.toString();
        const iso = (typeof d === "string" && d.length === 10) ? `${s}T00:00:00` : s;
        const dt = new Date(iso);
        if (isNaN(dt.getTime())) return "—";
        return dt.toLocaleDateString("pt-BR");
      } catch {
        return "—";
      }
    },

    async carregarSaldo() {
      if (!this.$route?.params?.id) return;
      this.saldoLoading = true;
      this.saldoError = "";
      try {
        const { data } = await axios.get(`/financeiro/contas-financeiras/${this.$route.params.id}/saldo`);
        this.saldoInfo = data;

        // se o GET da conta ainda não retornar snapshot, sincroniza a UI
        if (this.conta) {
          if (typeof data.saldo_atualizado !== "undefined") this.conta.saldo_atualizado = data.saldo_atualizado;
          if (typeof data.saldo_atualizado_em !== "undefined") this.conta.saldo_atualizado_em = data.saldo_atualizado_em;
        }
      } catch (e) {
        this.saldoError = e?.response?.data?.error || "Falha ao calcular saldo.";
        this.saldoInfo = null;
      } finally {
        this.saldoLoading = false;
      }
    },

    async carregarDetalhesConta() {
      this.carregando = true;
      try {
        const { data } = await axios.get(`/financeiro/contas-financeiras/${this.$route.params.id}`);

        // normaliza snapshot (o back pode já enviar)
        data.saldo_atualizado = data.saldo_atualizado != null ? parseFloat(data.saldo_atualizado) : null;
        data.saldo_atualizado_em = data.saldo_atualizado_em || null;

        // mantém compat: resolver nome do responsável se necessário
        this.conta = data;
        if (!data?.responsavel_nome || data.responsavel_nome.trim() === "") {
          await this.resolverResponsavelNome();
        }

        // carrega o saldo atual on-the-fly
        await this.carregarSaldo();
      } catch (error) {
        console.error("Erro ao carregar os detalhes da conta financeira:", error);
      } finally {
        this.carregando = false;
      }
    },

    async resolverResponsavelNome() {
      try {
        const id = this.conta?.responsavel_id;
        const tipo = (this.conta?.tipo_proprietario || "").trim();

        if (!id || !tipo) {
          this.conta.responsavel_nome = "Não informado";
          return;
        }

        if (tipo === "Pessoa Física") {
          const { data } = await axios.get(`/cadastros/pessoas-fisicas/${id}`);
          this.conta.responsavel_nome = data?.nome || "Não encontrado";
          return;
        }

        if (tipo === "Pessoa Jurídica") {
          const { data } = await axios.get(`/cadastros/pessoas-juridicas/${id}`);
          this.conta.responsavel_nome =
            data?.razao_social || data?.nome_fantasia || "Não encontrado";
          return;
        }

        this.conta.responsavel_nome = "Não informado";
      } catch (err) {
        console.error("Erro ao resolver responsável:", err);
        this.conta.responsavel_nome = "Não encontrado";
      }
    },

  },
  mounted() {
    this.carregarDetalhesConta();
  }
};
</script>

<style scoped>
.card {
  max-width: 90%;
  margin: 0 auto;
}

.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0rem;
}

.form-header h4 {
  margin: 0;
  font-weight: bold;
  text-align: left;
}

.form-content {
  margin-top: 1.5rem;
}

button.btn-sm {
  padding: 6px 12px;
}
</style>
